enum ReadingPanePosition {
    Off = 0,
    Right = 1,
    Bottom = 2,
}

export default ReadingPanePosition;
